import React from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import Navigation from "./components/Navigation";
import Home from "./components/Home";
import PlayerSummaries from "./components/PlayerSummaries";
import TeamRankings from "./components/TeamRankings";
import TournamentResults from "./components/TournamentResults";
import TournamentDetails from "./components/TournamentDetails";
import PlayerDetails from "./components/PlayerDetails";
import TeamDetails from "./components/TeamDetails";
import TeamPlayerRankings from "./components/TeamPlayerRankings";
import TeamPlayerDetails from "./components/TeamPlayerDetails";
import EventsList from "./events/events-list";
import EventDetail from "./events/event-detail";
import RegistrationForm from "./events/registration-form";
import Participants from "./events/participants";
import SwissStandings from "./events/swiss-standings";
import LeaguesList from "./leagues/leagues-list";
import LeagueDetail from "./leagues/league-detail";
import EventCalendar from "./events/calendar";
import ClubsList from "./clubs/clubs-list";
import ClubDetail from "./clubs/club-detail";
import LeagueStandings from "./leagues/standings";
import RoundDetail from "./leagues/round-detail";
import RoundLinkPage from "./leagues/round-link-page";
import ScoringPage from "./leagues/scoring-page";
import Footer from "./components/Footer";
import { PageViewTracker } from "./components/page-view-tracker";
import { HideInEmbed } from "./components/hide-in-embed";
import PrivacyPolicy from "./legal/privacy-policy";
import CookiePolicy from "./legal/cookie-policy";
import Terms from "./legal/terms";
import { AuthProvider } from "./auth/auth-context";
import { LoginPage } from "./auth/login-page";
import { SignupPage } from "./auth/signup-page";
import { MePage } from "./auth/me-page";
import "./App.css";

function App() {
  return (
    <Router>
      <AuthProvider>
        <PageViewTracker />
        <div className="App">
          <HideInEmbed>
            <Navigation />
          </HideInEmbed>
          <main className="main-content">
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/me" element={<MePage />} />
              <Route path="/" element={<Home />} />
            <Route path="/players" element={<PlayerSummaries />} />
            <Route path="/teams" element={<TeamRankings />} />
            <Route path="/team-players" element={<TeamPlayerRankings />} />
            <Route path="/tournaments" element={<TournamentResults />} />
            <Route
              path="/tournament/:tournamentId"
              element={<TournamentDetails />}
            />
            <Route path="/player/:playerId" element={<PlayerDetails />} />
            <Route path="/team/:teamKey" element={<TeamDetails />} />
            <Route
              path="/team-player/:playerId"
              element={<TeamPlayerDetails />}
            />
            <Route path="/events" element={<EventsList />} />
            <Route path="/events/calendar" element={<EventCalendar />} />
            <Route path="/events/:id" element={<EventDetail />} />
            <Route
              path="/events/:id/register/:categoryId"
              element={<RegistrationForm />}
            />
            <Route
              path="/events/:id/participants"
              element={<Participants />}
            />
            <Route
              path="/events/:id/swiss/:categoryId"
              element={<SwissStandings />}
            />
            <Route path="/clubs" element={<ClubsList />} />
            <Route path="/clubs/:slug" element={<ClubDetail />} />
            <Route path="/leagues" element={<LeaguesList />} />
            <Route path="/leagues/:id" element={<LeagueDetail />} />
            <Route
              path="/leagues/:id/standings"
              element={<LeagueStandings />}
            />
            <Route
              path="/leagues/:id/rounds/:roundId"
              element={<RoundDetail />}
            />
            <Route path="/scoring/:token" element={<ScoringPage />} />
            <Route path="/embed/scoring/:token" element={<ScoringPage embedded />} />
            <Route path="/embed/results/:token" element={<ScoringPage embedded resultsOnly />} />
            <Route path="/kolejka/:token" element={<RoundLinkPage />} />
            <Route path="/kolejka/:token/kod/:admitCode" element={<RoundLinkPage />} />
            <Route path="/prywatnosc" element={<PrivacyPolicy />} />
            <Route path="/cookies" element={<CookiePolicy />} />
            <Route path="/regulamin" element={<Terms />} />
          </Routes>
        </main>
        <HideInEmbed>
          <Footer />
        </HideInEmbed>
      </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
